<template>

<div class="main menus">
	<list-view :searchTerm="filters.search_term" :paging="paging" :definition="definition" :list="newsAlerts" @search="getList($event)" @updatePage="goToPage($event)" @getDetail="editNewsAlert($event)" :showRemove="true" @auditRemove="auditRemove" v-if="!loading">
		<template v-slot:filters>
			<div v-if="showFilters" class="filters">

				<div class="title">Filter news alerts by published/unpublished...</div>

				<ul class="checkbox-group">
					<li>
						<span :class="['pointer', 'far', filters.published ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('published')"></span>
						<label>Published</label>
					</li>
					<li>
						<span :class="['pointer', 'far', filters.unpublished ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('unpublished')"></span>
						<label>Unpublished</label>
					</li>
				</ul>
				<div :class="['button', hasFilters ? 'neutral' : 'disabled' ]" @click="clearFilters(true)">Clear Filters</div>
				<div class="button action" @click="addNewsAlert()"><span>Add News Alert</span></div>
			</div>
		</template>
	</list-view>

    <loading v-else></loading>

	<div v-if="showModal" class="modal">
		<div class="inner">
			<h2>{{ editingNewsAlert.content ? 'Edit' : 'Add' }} News Alert</h2>
			<div class="content">
				<label>Description</label>
				<input type="text" v-model="editingNewsAlert.description">
				<label>Content</label>
				<input type="text" v-model="editingNewsAlert.content">
				<label>Link URL</label>
				<input type="text" v-model="editingNewsAlert.link_url">
				<div class="form-quarter control-group">
					<label class="dark-font radio first">
						<input type="radio" v-model="editingNewsAlert.internal_use_only" :value="0">
						<span class="published"><i class="fas fa-check-circle"></i>Published</span>
					</label>
					<label class="dark-font radio last">
						<input type="radio" v-model="editingNewsAlert.internal_use_only" :value="1">
						<span class="unpublished"><i class="fas fa-check-circle"></i>Unpublished</span>
					</label>
				</div>
			</div>
			<div class="controls">
				<div class="button cancel" @click="cancelNewsAlert()">Cancel</div>
				<div class="button action" @click="saveNewsAlert()"><span>Save News Alert</span></div>
				<div v-if="editingNewsAlertMessage" class="message">{{ editingNewsAlertMessage }}</div>
			</div>
		</div>
	</div>

	<help-popup :helpLink="{83:'News Alerts', 100:'Website Template: Customizing News Alerts'}" :tours="false"></help-popup>

</div>

</template>

<script>
import HelpPopup from '@/components/HelpPopup.vue'

export default {
	name: 'menus',
	components: {
		'help-popup': HelpPopup
    },
	data() {
		return {
			loading: false,
			showFilters: true,
			newsAlerts: [],
			definition: [],
			showModal: false,
			editingNewsAlert: {},
			editingNewsAlertMessage: null,
			filters: {
				page: 1,
				search_term: '',
				published: false,
				unpublished: false,
			},
			paging: {},
			message: '',
			clientId: ''
		}
	},
	created() {
		this.getList()
	},
	computed: {
		hasFilters() {
			let filterIsSet = false
			for (var property in this.filters) {
				switch (property) {
					case 'hostname':
					case 'page':
					case 'source':
					case 'shopping_cart_id':
						break
					default:
						filterIsSet = this.filters[property] && this.filters[property] != ''
						break
				}
				if (filterIsSet) {
					return true
				}
			}
			return false
		}
	},
	methods: {
		getList(search_term) {
			if (search_term) {
				this.filters.search_term = search_term
			}
			this.loading = true
			this.apiCall({ destination: 'get_list_news_alerts', data: this.filters } ).then(obj => {
				this.loading = false
				this.newsAlerts = obj.news_alerts
				this.definition = obj.definition
				this.paging = obj.paging
			}).catch(err => {
				console.log(err)
			})
		},
		addNewsAlert() {
			this.editingNewsAlert = {
				content: null,
				link_url: null,
				inactive: 0,
				internal_use_only: 1
			}
			this.showModal = true
		},
		editNewsAlert(newsAlertID) {
			this.editingNewsAlert = this.$copy(this.newsAlerts[newsAlertID])
			this.showModal = true
		},
		cancelNewsAlert() {
			this.editingNewsAlert = {}
			this.showModal = false
		},
		saveNewsAlert() {
			if (this.editingNewsAlert.description == null || this.editingNewsAlert.description == '') {
				this.editingNewsAlertMessage = 'Description is a required field.'
				return
			}
			this.editingNewsAlertMessage = null
			this.apiCall({ destination: 'save_item_news_alert', data: this.editingNewsAlert } ).then(obj => {
				this.loading = false
				if (obj.status == 'success') {
					this.cancelNewsAlert()
					this.getList()
				} else {
					this.editingNewsAlertMessage = obj.message
				}
			}).catch(err => {
				this.loading = false
				console.log(err)
			})
		},
		auditRemove(newsAlertID) {
			this.editingNewsAlert = this.$copy(this.newsAlerts[newsAlertID])
			this.editingNewsAlert.inactive = 1
			this.saveNewsAlert()
		},
		clearFilters(getList) {
			this.filters = {
				page: 1,
				search_term: '',
				published: false,
				unpublished: false
			}
			if (getList) {
				this.getList()
			}
		},
		toggleFilter(which) {
			let currentValue = this.filters[which]
			this.filters.published = ''
			this.filters.unpublished = ''
			this.filters[which] = !currentValue
			this.filters.page = 1
			this.getList()
		},
		goToPage(page) {
			this.filters.page = page
			this.getList()
		}
	}
}
</script>

<style lang="scss" scoped>
</style>
